exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.limit-tabs[data-v-93e80930] {\n  padding: 12px;\n}\n.search-card[data-v-93e80930] {\n  margin-bottom: 20px;\n}\n.table-card[data-v-93e80930] {\n  margin-top: 0;\n}\n", ""]);

// exports
